module.exports = __webpack_public_path__ + "media/site/images/icons/logistics-icon-d181f1db7ee3203b483b2155560656ea.svg";